/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Cancel_ButtonInputs */

const en_tasks_cancel_button = /** @type {(inputs: Tasks_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_tasks_cancel_button = /** @type {(inputs: Tasks_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const ms_sg2_tasks_cancel_button = /** @type {(inputs: Tasks_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Tasks_Cancel_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_cancel_button = /** @type {((inputs?: Tasks_Cancel_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Cancel_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_cancel_button(inputs)
	if (locale === "fr") return fr_tasks_cancel_button(inputs)
	return ms_sg2_tasks_cancel_button(inputs)
});